import { ShieldCheck, RefreshCw, Lock, FileCheck2 } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const POINTS = [
  { icon: ShieldCheck, title: "Юр. гарантия от штрафа", text: "Если ФАС оштрафует за креатив, выпущенный по нашей вине с ошибкой — компенсируем 100% штрафа. Условия в оферте." },
  { icon: RefreshCw, title: "Возврат 14 дней", text: "Без объяснения причин. 1 клик в кабинете — деньги вернутся на карту в течение 3 банковских дней." },
  { icon: Lock, title: "Данные в РФ", text: "Серверы в Москве и СПб, шифрование TLS 1.3 + AES-256. Реестр операторов ПД РКН." },
  { icon: FileCheck2, title: "5 лет хранения", text: "Все erid, отчёты и подтверждения от ОРД доступны 5 лет — соответствует требованиям ФАС." },
];

export function GuaranteeBlock() {
  return (
    <section
      id="guarantee"
      aria-labelledby="guarantee-title"
      className="mx-auto mt-20 w-full max-w-6xl px-4"
    >
      <div className="glass-card relative overflow-hidden p-6 sm:p-10">
        <div className="absolute -right-20 -top-20 h-64 w-64 rounded-full opacity-20 blur-[100px]" style={{ background: "radial-gradient(circle, hsl(142 71% 45% / 0.6), transparent)" }} />
        <div className="relative grid gap-8 lg:grid-cols-[1fr_1.4fr]">
          <div>
            <p className="mb-2 text-xs font-bold uppercase tracking-[0.25em] text-success">Гарантии</p>
            <h2 id="guarantee-title" className="mb-4 text-2xl font-extrabold tracking-tight text-foreground sm:text-3xl md:text-4xl">
              4 причины спать спокойно
            </h2>
            <p className="mb-6 text-sm text-muted-foreground sm:text-base">
              Мы единственный сервис на рынке, который берёт на себя финансовую ответственность за ошибки в маркировке.
            </p>
            <Button asChild size="lg" className="gap-2 rounded-xl">
              <Link to="/garantii">Прочитать оферту</Link>
            </Button>
          </div>
          <div className="grid gap-3 sm:grid-cols-2">
            {POINTS.map((p) => (
              <div key={p.title} className="rounded-2xl border border-border/40 bg-secondary/20 p-4">
                <div className="mb-2 flex h-9 w-9 items-center justify-center rounded-xl bg-success/10">
                  <p.icon className="h-4 w-4 text-success" />
                </div>
                <h3 className="mb-1 text-sm font-bold text-foreground">{p.title}</h3>
                <p className="text-xs leading-relaxed text-muted-foreground">{p.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
